import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import FormEmailRows from "components/forms/form-email-block";
import { faPaperPlane } from "components/icon-library";
import { createEmpty } from "lib/locale";
import { LocaleString } from "models/locale";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import { useLocales } from "stores/hooks/locale";
import * as yup from "yup";

interface InvitesFormProps {
  onNext: (subject: LocaleString, message: LocaleString) => Promise<void>;
  onPrevious: () => Promise<void>;
}

const InvitesForm: FunctionComponent<InvitesFormProps> = ({
  onNext,
  onPrevious,
}) => {
  const locales = useLocales();

  const schema = yup
    .object({
      subject: yup.object().validateLocaleString(),
      message: yup.object().validateLocaleString(),
    })
    .required();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      subject: createEmpty("", locales),
      message: createEmpty("", locales),
    },
  });

  const handleSubmitUsers = async (formValues: any) => {
    const { subject, message } = formValues;
    onNext(subject, message);
  };

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onPrevious, text: "Edellinen" },
    { ...SubmitButton, text: `Lähetä kutsut`, postIcon: faPaperPlane },
  ];

  return (
    <Form methods={methods} onSubmit={handleSubmitUsers}>
      <FormEmailRows allowImport />
      <FormButtons buttons={buttons} />
    </Form>
  );
};

export default InvitesForm;
